// อ่านไฟล์ .xlsx ในเบราว์เซอร์ โดยไม่ต้องติดตั้งไลบรารีเพิ่ม
// .xlsx = ไฟล์ zip ที่ข้างในเป็น XML → แตก zip เอง แล้วอ่านชีต
// คืนค่า { sheetName, sheetNames, headers, rows: [{หัวคอลัมน์: 'ค่าเป็นข้อความ'}] }

const td = new TextDecoder('utf-8');

async function inflateRaw(bytes) {
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

async function unzip(buffer, wanted) {
  const u8 = new Uint8Array(buffer);
  const dv = new DataView(buffer);
  // หา End of Central Directory จากท้ายไฟล์
  let eocd = -1;
  for (let i = u8.length - 22; i >= Math.max(0, u8.length - 65557); i--) {
    if (dv.getUint32(i, true) === 0x06054b50) { eocd = i; break; }
  }
  if (eocd < 0) throw new Error('ไฟล์นี้ไม่ใช่ .xlsx (ถ้าเป็น .xls ให้เปิดใน Excel แล้ว Save As เป็น .xlsx ก่อน)');
  const count = dv.getUint16(eocd + 10, true);
  let p = dv.getUint32(eocd + 16, true);
  const out = {};
  for (let n = 0; n < count; n++) {
    if (dv.getUint32(p, true) !== 0x02014b50) break;
    const method = dv.getUint16(p + 10, true);
    const csize = dv.getUint32(p + 20, true);
    const nameLen = dv.getUint16(p + 28, true);
    const extraLen = dv.getUint16(p + 30, true);
    const commentLen = dv.getUint16(p + 32, true);
    const local = dv.getUint32(p + 42, true);
    const name = td.decode(u8.subarray(p + 46, p + 46 + nameLen));
    p += 46 + nameLen + extraLen + commentLen;
    if (!wanted(name)) continue;
    const lNameLen = dv.getUint16(local + 26, true);
    const lExtraLen = dv.getUint16(local + 28, true);
    const start = local + 30 + lNameLen + lExtraLen;
    const data = u8.subarray(start, start + csize);
    if (method === 0) out[name] = td.decode(data);
    else if (method === 8) out[name] = td.decode(await inflateRaw(data));
    else throw new Error('รูปแบบการบีบอัดในไฟล์ไม่รองรับ');
  }
  return out;
}

const decodeXml = (s) => s
  .replace(/_x([0-9A-Fa-f]{4})_/g, (_, h) => String.fromCharCode(parseInt(h, 16)))
  .replace(/&#x([0-9A-Fa-f]+);/g, (_, h) => String.fromCodePoint(parseInt(h, 16)))
  .replace(/&#(\d+);/g, (_, d) => String.fromCodePoint(Number(d)))
  .replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, '&');

const attr = (tag, name) => {
  const m = tag.match(new RegExp('\\b' + name + '="([^"]*)"'));
  return m ? decodeXml(m[1]) : null;
};

// ข้อความใน <si> หรือ <is> (รวม rich text หลายช่วง ไม่เอาคำอ่าน <rPh>)
const richText = (xml) => {
  const clean = xml.replace(/<rPh\b[\s\S]*?<\/rPh>/g, '');
  let s = '';
  for (const m of clean.matchAll(/<t\b[^>]*>([\s\S]*?)<\/t>|<t\b[^>]*\/>/g)) s += m[1] ? decodeXml(m[1]) : '';
  return s;
};

const colIndex = (ref) => {
  const letters = ref.replace(/\d+/g, '');
  let n = 0;
  for (const ch of letters) n = n * 26 + (ch.charCodeAt(0) - 64);
  return n - 1;
};

// รูปแบบตัวเลขที่เป็นวันที่
const BUILTIN_DATE = new Set([14, 15, 16, 17, 18, 19, 20, 21, 22, 45, 46, 47]);
function dateStyles(stylesXml) {
  const custom = {};
  for (const m of (stylesXml || '').matchAll(/<numFmt\b[^>]*\/?>/g)) {
    const id = Number(attr(m[0], 'numFmtId'));
    const code = (attr(m[0], 'formatCode') || '').replace(/"[^"]*"|\[[^\]]*\]|\\./g, '');
    if (/[dmy]/i.test(code) && !/^[#0.,%\s]*$/.test(code)) custom[id] = true;
  }
  const xfs = ((stylesXml || '').match(/<cellXfs\b[\s\S]*?<\/cellXfs>/) || [''])[0];
  const isDate = [];
  for (const m of xfs.matchAll(/<xf\b[^>]*\/?>/g)) {
    const id = Number(attr(m[0], 'numFmtId') || 0);
    isDate.push(BUILTIN_DATE.has(id) || !!custom[id]);
  }
  return isDate;
}

const pad = (n) => String(n).padStart(2, '0');
// ตัวเลขจำนวนเต็มเขียนแบบปกติ (4.046948186E9 → 4046948186, 99.0 → 99)
function numText(v) {
  const n = Number(v);
  if (Number.isFinite(n) && Number.isInteger(n) && Math.abs(n) < 1e15) return String(n);
  if (Number.isFinite(n) && /e/i.test(v)) return String(n);
  return v;
}
function serialToText(v) {
  const ms = Math.round((Number(v) - 25569) * 86400000);   // 25569 = 1970-01-01
  const d = new Date(ms);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}

export async function readXlsx(input, { sheetName, raw } = {}) {
  const buffer = input instanceof ArrayBuffer ? input : await input.arrayBuffer();
  const meta = await unzip(buffer, (n) => ['xl/workbook.xml', 'xl/_rels/workbook.xml.rels', 'xl/sharedStrings.xml', 'xl/styles.xml'].includes(n));
  if (!meta['xl/workbook.xml']) throw new Error('อ่านไฟล์ไม่ได้: ไม่พบโครงสร้าง Excel');

  const sheets = [...meta['xl/workbook.xml'].matchAll(/<sheet\b[^>]*\/?>/g)].map((m) => ({ name: attr(m[0], 'name'), rid: attr(m[0], 'r:id') }));
  const rels = Object.fromEntries([...(meta['xl/_rels/workbook.xml.rels'] || '').matchAll(/<Relationship\b[^>]*\/?>/g)]
    .map((m) => [attr(m[0], 'Id'), attr(m[0], 'Target')]));
  const sheet = sheetName ? sheets.find((s) => s.name === sheetName) : sheets[0];
  if (!sheet) throw new Error(`ไม่พบชีต ${sheetName || ''}`);
  let target = rels[sheet.rid] || '';
  target = target.startsWith('/') ? target.slice(1) : 'xl/' + target.replace(/^\.\//, '');

  const sheetXml = (await unzip(buffer, (n) => n === target))[target];
  if (!sheetXml) throw new Error('อ่านชีตไม่ได้');

  const shared = [...(meta['xl/sharedStrings.xml'] || '').matchAll(/<si\b[^>]*>([\s\S]*?)<\/si>|<si\b[^>]*\/>/g)].map((m) => (m[1] ? richText(m[1]) : ''));
  const isDate = dateStyles(meta['xl/styles.xml']);

  const grid = [];
  for (const rm of sheetXml.matchAll(/<row\b[^>]*>([\s\S]*?)<\/row>/g)) {
    const row = [];
    for (const cm of rm[1].matchAll(/<c\b([^>]*?)(?:\/>|>([\s\S]*?)<\/c>)/g)) {
      const a = cm[1]; const body = cm[2] || '';
      const ref = attr('<c ' + a + '>', 'r');
      const t = attr('<c ' + a + '>', 't') || 'n';
      const s = Number(attr('<c ' + a + '>', 's') || 0);
      const vm = body.match(/<v>([\s\S]*?)<\/v>/);
      let v = null;
      if (t === 's') v = vm ? shared[Number(vm[1])] ?? '' : null;
      else if (t === 'inlineStr') v = richText(body);
      else if (t === 'str' || t === 'e') v = vm ? decodeXml(vm[1]) : null;
      else if (t === 'b') v = vm ? (vm[1] === '1' ? 'TRUE' : 'FALSE') : null;
      else if (vm) v = isDate[s] ? serialToText(vm[1]) : numText(vm[1]);
      if (v === null || v === '') continue;
      row[ref ? colIndex(ref) : row.length] = v;
    }
    grid.push(row);
  }
  // raw = คืนตารางดิบทั้งชีต (ไฟล์ที่มีหัวรายงานอยู่ก่อนแถวหัวคอลัมน์)
  if (raw) return { sheetName: sheet.name, sheetNames: sheets.map((s) => s.name), grid };
  while (grid.length && !grid[0].some((v) => v != null && String(v).trim() !== '')) grid.shift();
  if (!grid.length) return { sheetName: sheet.name, sheetNames: sheets.map((s) => s.name), headers: [], rows: [] };

  // หัวคอลัมน์ซ้ำ (เช่น custcode 2 คอลัมน์) ใช้คอลัมน์แรก
  const headers = []; const seen = new Set();
  grid[0].forEach((h, i) => { const k = String(h ?? '').trim(); if (k && !seen.has(k)) { seen.add(k); headers[i] = k; } });
  const rows = [];
  for (const r of grid.slice(1)) {
    const o = {};
    let any = false;
    r.forEach((v, i) => { if (headers[i] && v != null && String(v).trim() !== '') { o[headers[i]] = String(v); any = true; } });
    if (any) rows.push(o);
  }
  return { sheetName: sheet.name, sheetNames: sheets.map((s) => s.name), headers: headers.filter(Boolean), rows };
}
